export const TIME_PER_CHUNK = 500; // ms

export const TranscriberClientEvents = {
  AUDIO_START: "audio:start",
  AUDIO_CHUNK: "audio:chunk",
  AUDIO_END: "audio:end",
  AUDIO_LISTEN: "audio:listen",
};

export const TranscriberServerEvents = {
  PROVIDER_WAIT: "provider:wait",
  PROVIDER_READY: "provider:ready",
  PROVIDER_UNAVAILABLE: "provider:unavailable",
  TRANSCRIPT_PARTIAL: "transcript:partial",
  TRANSCRIPT_COMPLETED: "transcript:completed",
  TRANSCRIPT_END: "transcript:end",
  CONNECT_ERROR: "connect_error",
  DISCONNECT: "disconnect",
  // Emitted by the transcriber with { code } (e.g. ROUTE_UNAVAILABLE, DRAINING).
  ERROR: "error",
};
